<p-confirmdialog />
<p-toast />
<div class="container px-4 py-10">
  <block-ui>
    <div class="w-full p-2 m-2">
      <!-- Header Section -->
      <div class="flex items-center justify-between">
        <div class="mb-7">
          <h1 class="mb-1 text-2xl font-semibold text-primary-200">
            Customers - Due Payment Processing
          </h1>
          <p class="text-sm text-primary-500">
            View all of your clients who are due for payment processing
          </p>
        </div>
        <div class="flex gap-2">
          <p-button
            icon="pi pi-download"
            label="Export"
            severity="secondary"></p-button>
        </div>
      </div>
    </div>
    <div class="w-full">
      <p-table
        #dt2
        [columns]="cols"
        dataKey="id"
        stripedRows
        [value]="filtered_customers"
        [scrollable]="true"
        [resizableColumns]="true"
        [autoLayout]="true"
        responsiveLayout="scroll"
        [paginator]="true"
        [globalFilterFields]="[
          'first_name',
          'last_name',
          'status',
          'autopay_status'
        ]"
        [rows]="25"
        selectionMode="multiple"
        [(selection)]="selectedCustomers"
        [tableStyle]="{ 'min-width': '50rem' }"
        [rowsPerPageOptions]="[25, 50, 100]">
        <ng-template #emptymessage>
          <tr>
            <td colspan="8">No customers found.</td>
          </tr>
        </ng-template>

        <!-- Table Header -->
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th style="width: 4rem"><p-tableHeaderCheckbox /></th>
            <th pResizableColumn pSortableColumn="first_name">
              First Name
              <p-sortIcon field="first_name" />
            </th>
            <th pResizableColumn pSortableColumn="last_name">
              Last Name
              <p-sortIcon field="last_name" />
            </th>
            <th pResizableColumn pSortableColumn="status">
              Status
              <p-sortIcon field="status" />
            </th>
            <th pSortableColumn="autopay_status">
              Autopay
              <p-sortIcon field="autopay_status" />
            </th>
            <th
              pResizableColumn
              pSortableColumn="subscriptions_total"
              style="text-align: right">
              Monthly $
              <p-sortIcon field="subscriptions_total" />
            </th>
            <th
              pResizableColumn
              pSortableColumn="current_balance"
              style="text-align: right">
              Balance
              <p-sortIcon field="current_balance" />
            </th>
            <th></th>
          </tr>
          <tr>
            <th></th>
            <th *ngFor="let col of columns">
              <p-columnFilter
                type="{{ col.type }}"
                field="{{ col.field }}"></p-columnFilter>
            </th>
            <th></th>
          </tr>
        </ng-template>

        <!-- Table Body -->
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <tr [pSelectableRow]="rowData">
            <p-tableCheckbox [value]="rowData" />
            <td>
              <a
                *ngIf="rowData.id"
                [routerLink]="['/admin/customers/view', rowData.id]"
                class="text-blue-600 hover:underline">
                {{ rowData.first_name }}
              </a>
              <span *ngIf="!rowData.id">
                {{ rowData.first_name }}
              </span>
            </td>
            <td>
              <a
                *ngIf="rowData.id"
                [routerLink]="['/admin/customers/view', rowData.id]"
                class="text-blue-600 hover:underline">
                {{ rowData.last_name }}
              </a>
              <span *ngIf="!rowData.id">
                {{ rowData.last_name }}
              </span>
            </td>
            <td>
              <span [ngClass]="rowData.status === 'ACTIVE' ? 'green' : 'red'">
                {{ rowData.status }}
                </span>
            </td>
            <td>
              <span [ngClass]="rowData.autopay_status ? 'green' : 'red'">
                {{ rowData.autopay_status | boolToText }}
              </span>
            </td>
            <td style="text-align: right">
              {{ rowData.subscriptions_total | currency : "USD" }}
            </td>
            <td style="text-align: right">
              {{ rowData.current_balance | currency : "USD" }}
            </td>
            <td>
              <p-button
                (click)="menuClicked(rowData); menu.toggle($event)"
                icon="pi pi-ellipsis-v" />
            </td>
          </tr>
        </ng-template>
      </p-table>
      <p-menu appendTo="body" #menu [model]="row_items" [popup]="true" />
    </div>
  </block-ui>
</div>
